// Polis, the Register tab of the new interface (10 October 2026).
// Texts that agree with a number have two forms, "singular | plural": the
// screen picks the form the way the language agrees it (1.7 seats, 1 seat).
export default {
  chargement: 'Loading…',
  fermer: 'Close',
  pct: '{n}%',
  joint: '{a}, {b}',
  erreur: {
    lecture: 'Could not load.',
    preuve: 'The proof of this projection is not available yet.',
    contenu: 'What was sealed for this projection is not available yet.',
  },
  bref: {
    aria: 'The register at a glance',
    scellees: 'sealed projection | sealed projections',
    dontEssais: 'including {n} trial | including {n} trials',
    confrontees: 'checked against the result | checked against the result',
    scrutinLe: 'the vote takes place on {jour}',
    scrutinAujourdhui: 'the vote takes place today',
    attenteResultat: 'awaiting the result',
    fideliteSieges: 'of seats placed as the polls place them, by twins who never read them',
    fideliteVoix: 'of the vote placed as the polls place it, by twins who never read them',
    vagueDu: 'wave of {jour}',
    sondagesSieges: 'seat of error per list in the polls, two weeks before the vote | seats of error per list in the polls, two weeks before the vote',
    sondagesPoints: 'point of error per candidate in the polls, two weeks before the vote | points of error per candidate in the polls, two weeks before the vote',
    surElections: 'measured over {n} past election | measured over {n} past elections',
  },
  scellees: {
    titre: 'Sealed projections',
    sousTitre: 'no one can touch them up: the fingerprint is checked every time they are opened · Paris time',
    vide: 'No sealed projection for this election yet. A projection sealed before the vote is recorded here, with its proof.',
    quand: '{jour}, {heure}',
    // Its wave and its kind (21 October 2026): sealed on its own when the wave was read, sealed by hand for good, or a trial.
    vague: {
      automatique: 'Wave of {jour}, sealed automatically',
      definitive: 'Wave of {jour}, final projection',
      essai: 'Wave of {jour}, trial',
    },
    // The same, when the content does not date its wave.
    seule: {
      automatique: 'Sealed automatically',
      definitive: 'Final projection',
      essai: 'Trial',
    },
    fourchette: '{bas} ~ {haut}',
    lectureOrion: 'Orion projection',
    lectureJumeaux: 'Twins alone',
    intacte: 'fingerprint intact',
    alteree: 'fingerprint altered',
    temoins: '{n} witness out of {sur} | {n} witnesses out of {sur}',
    contenu: 'Download what was sealed',
    contenuAria: 'Download what was sealed on {quand}',
    preuve: 'Download the proof',
    preuveAria: 'Download the proof of the projection of {quand}',
  },
  // How to check a sealed projection without Orion (21 October 2026): never how Orion computes it.
  verifier: {
    titre: 'How to check it, without Orion',
    telecharger: 'Download what was sealed and its proof, into the same folder.',
    deposer: 'On {site}, drop the proof, then the content; or, from the command line, in that folder: {commande}',
    commande: 'ots verify projection-xxxx.json.ots',
    bloc: 'The answer gives the Bitcoin block and its date. Until the anchoring is done, a few hours after sealing, the proof is “pending”: {commande} fetches the complete proof.',
    upgrade: 'ots upgrade projection-xxxx.json.ots',
    virgule: 'Changing a single comma in the content changes its fingerprint: the check fails.',
  },
  vagues: {
    titre: 'Each wave, against the polls of its week',
    sousTitreSieges: 'the share of seats placed as the poll average places them; on the right, the mean gap per list',
    sousTitreVoix: 'the share of the vote placed as the poll average places it; on the right, the mean gap per candidate',
    legende: 'The three readings',
    jumeaux: 'Twins alone',
    entourage: 'Their circle',
    calibree: 'The projection (set on the polls)',
    libelle: '{jour} · {libelle}',
    ecartSieges: '{n} seat | {n} seats',
    ecartPoints: '{n} point | {n} points',
  },
  sondages: {
    titre: 'What the polls are worth',
    surElections: 'measured over {n} past election | measured over {n} past elections',
    ecartSieges: 'seat of error per list, two weeks before the vote | seats of error per list, two weeks before the vote',
    ecartPoints: 'point of error per candidate, two weeks before the vote | points of error per candidate, two weeks before the vote',
    blocValeur: '± {n}',
    blocSieges: 'seat on the leading bloc, from one election to the next | seats on the leading bloc, from one election to the next',
    blocPoints: 'point on the leading bloc, from one election to the next | points on the leading bloc, from one election to the next',
    seuilValeur: '{tombees} / {listes}',
    seuil: 'lists polled at 3 to 6 seats fell to zero',
    sortiesSieges: 'seat of error per list for the exit polls | seats of error per list for the exit polls',
    sortiesPoints: 'point of error per candidate for the exit polls | points of error per candidate for the exit polls',
    sortiesSur: 'over {n} election | over {n} elections',
  },
  banc: {
    titre: 'The opinion bench',
    sousTitre: 'the twins against a published survey, question by question',
    evolution: '{a} → {b}',
    ecartUne: 'point of gap per answer, pass {passe} | points of gap per answer, pass {passe}',
    ecartDeux: 'point of gap per answer, from pass {a} to pass {b} | points of gap per answer, from pass {a} to pass {b}',
    sens: 'point of error on the direction of the answer | points of error on the direction of the answer',
    passe: 'Pass {v}',
    details: '{jour} · {territoire} · {n} question | {jour} · {territoire} · {n} questions',
    ligneEcart: 'gap per answer',
    ligneSens: 'error on the direction',
    pts: '{n} pt | {n} pts',
    juifs: 'Jewish {n}',
    arabes: 'Arab {n}',
  },
  participation: {
    titre: 'Past turnout',
    sousTitre: 'average and spread from one election to the next',
    valeur: '{moyenne}% ± {ecart}',
  },
}
